export default {
  'component.globalHeader.logout': 'ထွက်ခွာရန်',
};

